import { SkyLoader } from "@skypointcloud/skypoint-ui";
import { BrandMark } from "./BrandLogo";

export interface FullPageLoaderProps {
  /** What the wait is for ("Starting skyData…"); the loader's label, read by screen readers. */
  message: string;
  /**
   * Render as the page's `<main>` landmark (`#main-content`), for a route whose whole page is
   * this wait (the sign-in callback). Otherwise a plain container.
   */
  main?: boolean;
}

/**
 * The whole-screen wait before the shell exists: starting, signing in, loading the person's
 * access (owner, 2026-09-30: "This should be brand logo during data loading"). The coin stack sits
 * above the loader and its message, so every one of these waits carries the brand. The mark is
 * decorative: the message is what a screen reader should hear.
 */
export function FullPageLoader({ message, main = false }: FullPageLoaderProps) {
  const body = (
    <div className="flex flex-col items-center gap-6">
      <BrandMark className="h-16 w-16" />
      <SkyLoader size="large" label={message} labelPosition="below" />
    </div>
  );
  const className = "flex min-h-screen items-center justify-center bg-background";
  if (main) {
    return (
      <main id="main-content" className={className} role="main" data-testid="full-page-loader">
        {body}
      </main>
    );
  }
  return (
    <div className={className} data-testid="full-page-loader">
      {body}
    </div>
  );
}
